import EJSON from 'ejson';
export class Literal {
    constructor(value) {
        this.value = value;
    }
    // Convert our type to JSON.
    toJSONValue() {
        return {
            value: EJSON.toJSONValue(this.value),
        };
    }
    // Unique type name.
    typeName() {
        return 'Literal';
    }
}
//# sourceMappingURL=literal.js.map